export function formatExpert(response: any): null | any[] {
  if (!Array.isArray(response)) {
    return null;
  }
  const expertList: any[] = [];
  for (const item of response) {
    if (!item) {
      continue;
    }
    const obj: any = {};
    obj.id = item.user_id;
    obj.imageUrl = item.avatar_url;
    obj.name = item.user_name;
    obj.company = item.company;
    obj.department = item.department;
    obj.position = item.position;
    obj.isFollow = item.is_follow;
    obj.isFollowed = item.is_followed;
    expertList.push(obj);
  }
  return expertList;
}
export function formatDynamicExpert(response: any): null | any[] {
  const dynamicList = response.updates;
  if (!Array.isArray(dynamicList)) {
    return null;
  }
  const expertList: any[] = [];
  for (const item of dynamicList) {
    if (!item) {
      continue;
    }
    const obj: any = {};
    obj.id = item.following_user_id;
    obj.imageUrl = item.following_user_avatar;
    obj.name = item.following_user_name;
    obj.dynamic = '更新了' + item.update_type + '条动态';
    obj.content = item.update_items;
    obj.isDynamic = true;
    obj.update_type = item.update_type;
    expertList.push(obj);
  }
  return expertList;
}

export function formatHomeMessage(response: any): null | any[] {
  const messageList = response;
  if (!Array.isArray(messageList)) {
    return null;
  }
  const expertList: any[] = [];
  const unreadCount = messageList.length;
  for (const item of messageList) {
    if (!item) {
      continue;
    }
    const obj: any = {};
    obj.id = item.message.id;
    obj.imageUrl = item.sender.avatar;
    obj.name = item.sender.name;
    obj.dynamic = item.message.title;
    obj.content = item.message.content;
    obj.isDynamic = true;
    obj.count = unreadCount;
    expertList.push(obj);
  }
  return expertList;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/expert/ExpertSquare/util.ts